const initReactWidgetList = {
  leftMenu: "react-left-bar",
  adminSectionTab: "react-admin-tab-target",
};
const reactWidgetList = Object.assign(
  {
    newProjectModal: "new-project-button-target",
    csvIngestion: "csv-ingestion-target",
    csvImport: "project-list-table-target",
    projectDetailsTab: "project-details-tab",
    globalLoader: "global-react-components",
    react2faAuth: "react-2fa-auth",
    projectTitleTopBar: 'project-title-topbar-target',
  },
  initReactWidgetList
);
document.addEventListener("DOMContentLoaded", function (event) {
  Object.keys(initReactWidgetList).map((key) => {
    const target = document.getElementById(reactWidgetList[key]);
    target && window.initReactWidget(target, key);
  });
});
window.loadReact = () =>
  Object.keys(reactWidgetList).map((key) => {
    const target = document.getElementById(reactWidgetList[key]);
    target && window.initReactWidget(target, key);
  });
// below moved to app.js to wait for app to load fully
// setTimeout(() => window.loadReact && window.loadReact());



// WEBPACK FOOTER //
// ./resources/assets/js/react-loader.js